import store from '@/store';
import { showNotification } from '@/plugins/notification';

export async function authErrorHandler(response) {
  let error = response?.status || response?.statuscCode;
  if (error === 401) {
    showNotification('error', `Error ${error}`, 'Session expired. Please log in to continue.', 5000);
    store.dispatch('logOut', error);
  }
  if (error === 403 && response.code === 403021) {
    showNotification(
      'error',
      `Error ${error}`,
      'This account no longer exists. Contact support for help, or log out to return to the home screen.',
      5000,
    );
    store.dispatch('logOut', error);
  }
}
